import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "linkListContainer", "linkList", "title"];

  connect() {
    if(this.selectTarget){
      this.updateTitle()
      this.showList(this.selectTarget.value)
    }
  }

  change(event) {
    this.updateTitle()
    this.showList(event.target.value)
  }

  updateTitle() {
    const select = this.selectTarget as HTMLSelectElement
    const selectedValue = select.value

    let selectedOptGroupLabel = ""
    for (const optgroup of select.querySelectorAll("optgroup")) {
      for (const option of optgroup.querySelectorAll("option")) {
        if ((option as HTMLOptionElement).value === selectedValue) {
          selectedOptGroupLabel = (optgroup as HTMLOptGroupElement).label
        }
      }
    }

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = selectedOptGroupLabel || "Edition"
    }
  }

  syncSearchStudyKey(event) {
    const hiddenField = document.getElementById("fuzzysearch_study_key") as HTMLInputElement
    if (hiddenField) {
      hiddenField.value = event.target.value
    }

    const searchInput = document.getElementById("fuzzysearch_input") as HTMLInputElement
    if (searchInput && searchInput.value.trim() !== "") {
      searchInput.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }

  showList(listName) {
    this.linkListContainerTargets.forEach(container => {
      let hasMatch = false

      this.linkListTargets.forEach(list => {
        const matches = list.dataset.linkListName === listName
        list.classList.toggle("hidden", !matches)
        if (matches) hasMatch = true
      })

      container.classList.toggle("hidden", !hasMatch)
    })
  }
}